import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute, computed, numberAttribute, signal } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { ButtonProperty } from 'src/app/core/models/button.model';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    DialogComponent,
    MyButtonComponent
  ],
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoDialogComponent {
  @Input() title?: string
  @Input() message?: string
  @Input() type?: 'success' | 'info' | 'warning' | 'error' = 'info'
  @Input() acceptButton: ButtonProperty = {
    color: 'basic',
    label: 'Ok',
  };
  @Input({ transform: booleanAttribute }) autoClose: boolean = false;
  @Input({ transform: numberAttribute }) autoCloseTime: number = 5;

  public closeTimer = signal(-1);
  public acceptButtonLabel = computed(() => this.acceptButton.label + (this.closeTimer() > -1 ? ` (${this.closeTimer()})`:''))

  constructor(
    private dialogRef: MatDialogRef<InfoDialogComponent>
  ) {}

  get icon() {
    switch (this.type) {
      case 'success': return 'task_alt';
      case 'info': return 'info';
      case 'warning': return 'warning';
      case 'error': return 'error';
      default: return 'info';
    }
  }

  get color() {
    switch (this.type) {
      case 'success': return 'text-green-400';
      case 'info': return 'text-blue-400';
      case 'warning': return 'text-yellow-400';
      case 'error': return 'text-red-400';
      default: return 'text-blue-400';
    }
  }

  setAutoClose(timer: number = 5) {
    this.closeTimer.set(timer);
    this.dialogRef.afterOpened().subscribe(() => {
      setInterval(() => {
        this.closeTimer.update((value) => value - 1);
        if (this.closeTimer() === 0) {
          this.dialogRef.close();
        }
      }, 1000)
    })
  }

  onAcceptButtonClick() {
    this.dialogRef.close();
  }
}
